import Events from '_utils/events';
import { cloneDeep } from '_utils';
import {
  CELL,
  _PUZZLE_CLOSE_ALL_MODAL_,
} from '../../modules/puzzle/components/PuzzleModel';

const MODAL_POSITION_TOP = 0;
const MODAL_POSITION_LEFT = 0;

const MODAL_OFFSET_LEFT = 115;
const MODAL_OFFSET_TOP = 4;
const MODAL_TOP_LIMIT = 100;

export default {
  data() {
    return {
      positionTop: MODAL_POSITION_TOP,
      positionLeft: MODAL_POSITION_LEFT,
      openBelow: false,
      show: false,
      cell: cloneDeep(CELL),
    };
  },
  methods: {
    applyPosition(cellRect, horizontalOffset = MODAL_OFFSET_LEFT) {
      if (!cellRect) return;
      const tooCloseToTop = cellRect.top < MODAL_TOP_LIMIT;
      this.openBelow = tooCloseToTop;
      this.positionTop = tooCloseToTop
        ? cellRect.top + cellRect.height + MODAL_OFFSET_TOP
        : cellRect.top - MODAL_OFFSET_TOP;
      this.positionLeft = cellRect.left + cellRect.width / 2 - horizontalOffset;
    },
    close() {
      this.show = false;
    },
    registerModalEvents(openEvent, openHandler) {
      this._openEvent = openEvent;
      Events.$on(openEvent, openHandler);
      Events.$on(_PUZZLE_CLOSE_ALL_MODAL_, this.close);
    },
  },
  destroyed() {
    Events.$off(this._openEvent);
    Events.$off(_PUZZLE_CLOSE_ALL_MODAL_, this.close);
  },
};
